import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch, computed, onMounted } from "vue";
import Divider from "./Divider.vue";
import SideMenuComponent from "./SideMenuComponent.vue";
import TopMenuComponent from "./TopMenuComponent.vue";
import { nestedMenu } from "./main-menu";
import { useRoute } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenu',
  props: {
  position: String,
  layout: String,
},
  setup(__props) {

const props = __props

const formattedMenu = ref([]);

const route = useRoute();
const store = useStore();



onMounted(() => {
  formattedMenu.value = nestedMenu(store.getters.getMenu, route);
});

watch(
  () => route.path,
  () => {
    formattedMenu.value = nestedMenu(store.state.menu, route);
  }
);

// TODO remove delay from menu change
watch(
  () => store.state.menu,
  () => {
    formattedMenu.value = nestedMenu(store.state.menu, route);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.position === 'side' || __props.position === 'simple')
      ? (_openBlock(), _createElementBlock("nav", {
          key: 0,
          class: _normalizeClass([
      'hidden md:block overflow-x-hidden',
      {
        'pr-5 pt-14 pb-16  w-[85px] xl:w-[230px]':
          __props.layout === 'rubick' && __props.position === 'side',
        'pr-5 pt-14 pb-16  w-[85px]':
          __props.layout === 'rubick' && __props.position === 'simple',
      },
      {
        'w-[105px] xl:w-[260px] pt-[110px] px-5 pb-16  z-50':
          __props.layout === 'enigma' && __props.position === 'side',
        'w-[105px] px-5 pb-16 pt-[110px] z-50':
          __props.layout === 'enigma' && __props.position === 'simple',
      },
      {
        'w-[105px] xl:w-[250px] px-5 pt-8 pb-16 ':
          __props.layout === 'icewall' && __props.position === 'side',
        'w-[105px] px-5 pt-8 pb-16 ':
          __props.layout === 'icewall' && __props.position === 'simple',
      },
      {
        'md:w-[105px] xl:w-[250px] pt-14 px-5 pb-16 z-1':
          __props.layout === 'tinker' && __props.position === 'side',
        'md:w-[105px] xl:w-[105px] pt-14 px-5 pb-16 z-10':
          __props.layout === 'tinker' && __props.position === 'simple',
      },
    ])
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formattedMenu.value, (menu, index) => {
              return (_openBlock(), _createBlock(SideMenuComponent, {
                key: index,
                menuIndex: index,
                menu: menu,
                isRoot: true,
                layout: __props.layout,
                position: __props.position
              }, null, 8, ["menuIndex", "menu", "layout", "position"]))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (__props.position === 'top')
      ? (_openBlock(), _createElementBlock("nav", {
          key: 1,
          class: _normalizeClass([
      'z-[51] hidden md:block',
      {
        'relative': __props.layout === 'rubick',
      },
      {
        'relative pt-16 -mt-4': __props.layout === 'enigma',
        // Animation
        'opacity-0 animate-[0.4s_ease-in-out_0.2s_intro-top-menu] animate-fill-mode-forwards':
          __props.layout === 'enigma',
      },
      {
        'md:px-6 -mt-2 xl:-mt-[3px]': __props.layout === 'icewall',
        'animate-[0.4s_ease-in-out_0.3s_intro-top-menu] animate-fill-mode-forwards opacity-0 translate-y-[35px]':
          __props.layout === 'icewall',
        relative: __props.position !== 'top' && __props.layout === 'icewall',
        'absolute pt-[67px]': __props.position === 'top' && __props.layout === 'icewall',
      },
      {
        'relative py-5': __props.layout === 'tinker',
        'translate-y-[50px] opacity-0 animate-[0.4s_ease-in-out_0.2s_intro-top-menu] animate-fill-mode-forwards':
          __props.layout === 'tinker',
      },
    ])
        }, [
          _createElementVNode("ul", {
            class: _normalizeClass([
        {
          'pb-3 xl:pb-0 xl:px-[50px] flex flex-wrap': __props.layout === 'rubick',
        },
        {
          'flex flex-wrap px-6 xl:px-[50px]': __props.layout === 'enigma',
        },
        {
          'h-[50px] flex flex-wrap': __props.layout === 'icewall',
        },
        {
          'flex flex-wrap h-[58px] px-6 xl:px-[50px]': __props.layout === 'tinker',
        },
      ])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formattedMenu.value, (menu, index) => {
              return (_openBlock(), _createBlock(TopMenuComponent, {
                key: index,
                menuIndex: index,
                menu: menu,
                isRoot: true,
                layout: __props.layout
              }, null, 8, ["menuIndex", "menu", "layout"]))
            }), 128))
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})